import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoryService } from 'app/services/models/category.service';
import { KindService } from 'app/services/models/kind.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-category-dialog',
  templateUrl: './create-category-dialog.component.html',
  styleUrls: ['./create-category-dialog.component.scss']
})
export class CreateCategoryDialogComponent implements OnInit {

  @Input() data: { kindId?: number };

  categoryForm: FormGroup;
  kinds:any[] = [];

  categories: any[] = [];
  editingCategoryId: number | null = null; // Güncelleme için id

  constructor(private fb: FormBuilder,
    private categoryService: CategoryService,
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private kindService: KindService) { }

  async ngOnInit() {
    this.categoryForm = this.fb.group({
      name: [null],
      kindId: [null, Validators.required]
    });
    await this.getAllKinds();
    if (this.data.kindId != null) {
      await this.getAllCategory();
      if(this.data.kindId != null){
        this.categoryForm.patchValue({
          kindId: this.data.kindId
        });
      }
    }
  }

  async getAllCategory() {
    const data = await this.categoryService.getAllCategory(0, 100, '', this.data.kindId);
    console.log(data);
    this.categories = data.categories;
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKind('', 0, 100);
    console.log(data);
    this.kinds = data.types;
  }

  async onSumbit() {
    if (this.categoryForm.invalid) {
      return;
    }

    const categoryData = {
      name: this.categoryForm.value.name,
      kindId: this.data.kindId
    };

    if(this.editingCategoryId){ // Güncelleme
      const result = await this.categoryService.updateCategory(this.editingCategoryId, categoryData.name, categoryData.kindId);
      if(result.status){
        this.toastrService.success(result.message);
        this.editingCategoryId = null;
        this.closeModal(true);
      } else {
        this.toastrService.error(result.message);
      }
    } else { // Yeni kategori ekleme
      const result = await this.categoryService.createCategory(categoryData.name, categoryData.kindId);
      if(result.status){
        this.toastrService.success(result.message);
        this.closeModal(true);
      } else {
        this.toastrService.error(result.message);
      }
    }
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }

  editCategory(category: any) {
    console.log(category);
    this.editingCategoryId = category.id;
    this.categoryForm.patchValue({
      name: category.categoryName,
      kindId: category.kindId
    });
    // Dilersen burada güncelleme modal açabilirsin veya formu kullanabilirsin
  }
}